import router from './router'

router.beforeEach((to, from, next) => {
  if (to.name == null) {
    next({ path: '/' })
  } else {
    next()
  }
})


// WEBPACK FOOTER //
// ./src/permission.js